import { getEnv } from '@/composables/useEnv'
import Intercom, {
  show,
  showArticle,
  shutdown
} from '@intercom/messenger-js-sdk'
import { IUserFromToken } from '@lifk/types'

export function loadIntercom(user?: IUserFromToken) {
  // const env = getEnv('VITE_APP_ENV')

  if (
    // (env === 'staging' || env === 'production') &&
    user &&
    user.role !== 'guest'
  ) {
    Intercom({
      app_id: getEnv('VITE_APP_INTERCOM_APP_ID'),
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      user_id: user._id
    })
  } else {
    Intercom({
      app_id: getEnv('VITE_APP_INTERCOM_APP_ID')
    })
  }
}

export function closeIntercom() {
  shutdown()
}

export function showMessenger() {
  show()
}

export function loadArticle(id) {
  showArticle(id)
}
